import React from 'react';
import { SectionHeading } from './SectionHeading';
import { Search, MousePointer2, Share2, PenTool, Layout, MapPin } from 'lucide-react';
const services = [{
  icon: Search,
  title: 'SEO Optimization',
  description: 'Rank higher on Google with our technical and content-driven SEO strategies tailored for UK markets.'
}, {
  icon: MousePointer2,
  title: 'PPC Advertising',
  description: 'Instant traffic and leads with high-ROI Google Ads and social media paid campaigns.'
}, {
  icon: Share2,
  title: 'Social Media Marketing',
  description: 'Build a loyal community and engage your audience across Facebook, Instagram, LinkedIn, and TikTok.'
}, {
  icon: PenTool,
  title: 'Content Marketing',
  description: 'Compelling blog posts, articles, and copy that establishes authority and converts visitors.'
}, {
  icon: Layout,
  title: 'Web Design',
  description: 'Fast, mobile-responsive, and conversion-optimized websites that look great and perform better.'
}, {
  icon: MapPin,
  title: 'Local SEO',
  description: 'Dominate your local area. Get found by customers in your city when they need you most.'
}];
export function Services() {
  return <section id="services" className="py-20 bg-slate-50" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <SectionHeading title="Our Digital Expertise" subtitle="Comprehensive Solutions" data-id="element-92" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-93">
          {services.map((service, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 group hover:-translate-y-1" data-id="element-94">
              <div className="w-14 h-14 bg-green-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-green-600 transition-colors duration-300" data-id="element-95">
                <service.icon className="w-7 h-7 text-green-600 group-hover:text-white transition-colors duration-300" data-id="element-96" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-97">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-98">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}